import { fetchAll } from './fetch';

export default fetchAll('credits', {
  apiUrl: 'https://sistema.yacopini.com.ar/intranet/webservice'
});
